(function ($) {
    $(function () {
        $('.customer-login-bar__override select').each(function(){
            $(this).bind('change', function(){

                let url = $(this).children('option').filter(':selected').val();
                if (url !== '') {
                    $('.customer-login-bar-model').show();
                    setTimeout(function(){
                        if (window.location.href.includes('?')) {
                            window.location.href = window.location.href + '&' + url;
                        } else {
                            window.location.href = window.location.href + '?' + url;
                        }
                    }, 100);
                }
            });
        });
    });
})(jQuery);
